export default {
  inserted: (el) => {
    function loadImage() {
      const imageElement = el.nodeName === 'IMG' ? el : null;
      if (imageElement) {
        imageElement.src = imageElement.dataset.src;
      } else {
        console.warn('lazyload directive should only be applied to HTMLImageElements. Currently applied to:', el);
      }
    }

    function handleIntersect(entries, observer) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          loadImage();
          observer.unobserve(el);
        }
      });
    }

    function createObserver() {
      let rootNode = null;
      // determine if this is trying to lazy-load an image in one of the image modals
      if (
        el.parentNode.parentNode.parentNode.className === 'standard-image-selector-modal-image-grid' ||
        el.parentNode.parentNode.parentNode.className === 'licensed-image-selector-modal-image-grid'
      ) {
        rootNode = el.parentNode.parentNode.parentNode;
      }
      const options = {
        root: rootNode, // if null, will just refer to viewport
        rootMargin: '0px 0px 400px 0px',
        threshold: '0',
      };
      const observer = new IntersectionObserver(handleIntersect, options);
      observer.observe(el);
    }
    if (window['IntersectionObserver']) {
      createObserver();
    } else {
      loadImage();
    }
  },
};
